"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigationContext = exports.NavigationContextProvider = void 0;
var react_1 = __importStar(require("react"));
var react_2 = require("react");
var react_3 = require("react");
var react_4 = require("react");
var zod_1 = require("zod");
var PubSub_1 = require("../PubSub/PubSub");
var StoredState_1 = require("../StoredState/StoredState");
var navigationContext = (0, react_4.createContext)(undefined);
var NavigationContextProvider = function (_a) {
    var _b = _a.mode, mode = _b === void 0 ? "public" : _b, projectId = _a.projectId, value = _a.value, children = _a.children;
    var _c = __read((0, StoredState_1.useLocalStorage)({
        key: "navShowNavWhileEditing:".concat(projectId),
        schema: zod_1.z.boolean(),
        default: true,
    }), 2), showNavWhileEditing = _c[0], setShowNavWhileEditing = _c[1];
    var _d = __read((0, StoredState_1.useLocalStorage)({
        key: "navShowHiddenItems:".concat(projectId),
        schema: zod_1.z.boolean(),
        default: true,
    }), 2), showHiddenItems = _d[0], setShowHiddenItems = _d[1];
    var _e = __read((0, react_2.useState)(false), 2), isNavDrawerOpen = _e[0], setIsNavDrawerOpen = _e[1];
    var projectWrapper = typeof document !== "undefined" && document.querySelector(".project-content-wrapper");
    (0, react_1.useEffect)(function () {
        if (mode === "editor" && projectWrapper) {
            if (showNavWhileEditing) {
                projectWrapper.removeAttribute("hide-navigation");
            }
            else {
                projectWrapper.setAttribute("hide-navigation", "true");
            }
        }
    }, [showNavWhileEditing, mode, projectWrapper]);
    (0, react_1.useEffect)(function () {
        if (mode === "editor" && projectWrapper) {
            if (isNavDrawerOpen) {
                projectWrapper.setAttribute("navigation-drawer-open", "true");
            }
            else {
                projectWrapper.removeAttribute("navigation-drawer-open");
            }
        }
    }, [isNavDrawerOpen, mode, projectWrapper]);
    PubSub_1.PubSub.subscribe("qwilr:nav-show-while-editing-toggled", function (_a) {
        var isVisible = _a.isVisible;
        setShowNavWhileEditing(isVisible);
    });
    var handleSetShowNavWhileEditing = function (show) {
        PubSub_1.PubSub.publish("qwilr:nav-show-while-editing-toggled", { isVisible: show });
        setShowNavWhileEditing(show);
    };
    PubSub_1.PubSub.subscribe("qwilr:nav-drawer-toggled", function (_a) {
        var isOpen = _a.isOpen;
        setIsNavDrawerOpen(isOpen);
    });
    return (react_1.default.createElement(navigationContext.Provider, { value: __assign(__assign(__assign(__assign({}, value), (mode === "editor"
            ? { showHiddenItems: showHiddenItems, setShowHiddenItems: setShowHiddenItems }
            : { showHiddenItems: false, setShowHiddenItems: function () { } })), (mode === "editor"
            ? { showNavWhileEditing: showNavWhileEditing, setShowNavWhileEditing: handleSetShowNavWhileEditing }
            : { showNavWhileEditing: true, setShowNavWhileEditing: function () { } })), { isNavDrawerOpen: isNavDrawerOpen }) }, children));
};
exports.NavigationContextProvider = NavigationContextProvider;
var useNavigationContext = function () {
    var context = (0, react_3.useContext)(navigationContext);
    if (!context) {
        throw new Error("useNavigationContext must be used inside a NavigationContextProvider");
    }
    return context;
};
exports.useNavigationContext = useNavigationContext;
